import { api } from './api'
import { throwApiError } from './apiHelpers'

function assertSuccess(body: unknown) {
  const b = body as { success?: boolean; message?: string; data?: unknown }
  if (!b?.success) {
    throw new Error(b?.message || 'Request failed')
  }
  return b.data
}

export type CustomDomainStatus = 'none' | 'pending' | 'active' | 'failed'

export type StoreCustomDomainResult = {
  id: number
  organisationId: number
  subdomain: string
  customDomain: string | null
  customDomainStatus: CustomDomainStatus
  customDomainVerifiedAt: string | null
  publicUrl?: string
}

/**
 * super_admin — set / clear / activate a store custom domain alias.
 */
export async function patchStoreCustomDomain(
  storeId: string | number,
  body: { customDomain?: string | null; customDomainStatus?: CustomDomainStatus },
): Promise<StoreCustomDomainResult> {
  try {
    const { data } = await api.patch(
      `/admin/stores/${encodeURIComponent(String(storeId))}/custom-domain`,
      body,
    )
    return assertSuccess(data) as StoreCustomDomainResult
  } catch (e) {
    throwApiError(e, 'Failed to update custom domain')
  }
}
